export default __webpack_public_path__ + "static/media/cg-bg.2c6ba850.jpg";